import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    ETAPA: 'Tipos de Evento'
}

export default [
    {
        name: ROUTER_NAMES.ETAPA,
        path: '/tipo-evento',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Tipos de Evento',
            searchDescription: 'Veja todas os Tipos de Eventos cadastrados',
            searchTerms: ['evento','tipo'],
            hasRole: 'role/eventoTipo'
        },
        component: () => import('@/views/EventoTipo')
    },
]